import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from "@angular/core";
import {Job} from "../shared/job.model";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {JobTypeService} from "../../shared/job-type/job-type.service";
import moment from "moment-timezone"
import {Language} from "../../shared/language/language.model";
import {LanguageService} from "../../shared/language/language.service";
import {Events, ModalController} from "ionic-angular";
import {PlacesSearchModal} from "../../../app/components/places-search-modal/places-search-modal.component";
import {User} from "../../shared/user/user.model";
import {JobType} from "../../shared/job-type/job-type.model";
import {InterpreterSearchModal} from "../../../app/components/interpreter-search-modal/interpreter-search-modal.component";
import {ProfileService} from "../../profile/profile.service";
import {ToastService} from "../../../app/core/toast.service";
import {TranslateService} from "@ngx-translate/core";
import {ColleagueSearchModal} from "../../../app/components/colleague-search-modal/colleague-search-modal.component";
import {Speciality} from "../../shared/specialities/speciality.model";
import {SpecialitiesSelectModal} from "../../../app/components/specialities-select-modal/specialities-select-modal.component";

@Component({
  selector: 'app-job-edit-form',
  templateUrl: 'job-edit-form.component.html',

})
export class JobEditFormComponent implements OnInit, OnDestroy, OnChanges{
  jobIsTooShortAlertVisible: boolean;
  jobIsInThePastAlertVisible: boolean;
  jobIsInThePast: boolean;
  @Input('job') job: Job;
  form: FormGroup;
  jobTypes: { [s: string]: JobType } = {};
  jobTypeKeys: string[];
  maxStartDate: string;
  minStartDate: string;
  languages: Language[] = [];
  specialities: Speciality[] = [];
  typeSub;
  specificInterpreterRequiredSub;
  submitted:boolean = false;
  genders: string[] = ['male', 'female'];

  private userControlsConfig = {
    starts_at: ['', Validators.required],
    ends_at: ['', Validators.required], //TODO: depends on type
    address: ['', Validators.required],
    language1: ['', Validators.required],
    language2: ['', Validators.required],
    required_gender: [''],
    preferred_interpreter: [null],
    interpreter: [null, Validators.required],
    interpretation_receiver_name: ['', Validators.required],
    interpretation_receiver_birthdate: [''],
    publisher: [null, Validators.required],
    description: [''],
    type: ['', Validators.required],
    remote_contact_info: ['', Validators.required],
    specificInterpreterRequired: [false],
    file_entries: [[]]
  };

  constructor(private fb: FormBuilder,
              private jobTypeService: JobTypeService,
              private languageService: LanguageService,
              private modalCtrl: ModalController,
              private events: Events,
              private profileService: ProfileService,
              private toast: ToastService,
              private translate: TranslateService
  ) {
    this.form = this.fb.group(this.userControlsConfig);

    this.maxStartDate = moment({year: moment().year() + 2}).format();
    this.minStartDate = moment({year: moment().year() - 1}).format();
  }

  ngOnInit(){
    this.getJobTypes();

    this.languageService.getLanguages()
      .subscribe(languages => this.languages = languages);

    this.events.subscribe('place:selected', (place) => this.updateAddress(place));
    this.events.subscribe('interpreter:selected', (interpreter) => this.onInterpreterSelected(interpreter));
    this.events.subscribe('publisher:selected', (publisher) => this.onPublisherSelected(publisher));
    this.events.subscribe('participant:selected', (colleague) => this.onParticipantSelected(colleague));
    this.events.subscribe('preferred_interpreter:selected', (interpreter) => this.onPreferredInterpreterSelected(interpreter));
    this.events.subscribe('undesirable_interpreter:selected', (interpreter) => this.onUndesirableInterpreterSelected(interpreter));
    this.events.subscribe('speciality:selected', (interpreter) => this.onSpecialitySelected(interpreter));
    this.events.subscribe('job_edit_form:submitted', () => this.onFormSubmit());

    // Update validators when job type changes
    this.typeSub = this.form.get('type').valueChanges
      .subscribe((value) => this.onTypeValueChanges(value));

    this.specificInterpreterRequiredSub = this.form.get('specificInterpreterRequired').valueChanges
      .subscribe((value) => this.onSpecificInterpreterRequiredValueChanges(value));
  }

  ngOnDestroy(){
    this.events.unsubscribe('place:selected');
    this.events.unsubscribe('interpreter:selected');
    this.events.unsubscribe('publisher:selected');
    this.events.unsubscribe('participant:selected');
    this.events.unsubscribe('preferred_interpreter:selected');
    this.events.unsubscribe('undesirable_interpreter:selected');
    this.events.unsubscribe('speciality:selected');
    this.events.unsubscribe('job_edit_form:submitted');

    this.typeSub.unsubscribe();
    this.specificInterpreterRequiredSub.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges){
    if(this.job){
      if(!this.job.id) {
        this.prefillProfile();
      }

      if(this.job.required_gender || this.job.preferred_interpreter_id
        || (this.job.undesirable_interpreters && this.job.undesirable_interpreters.length)
        || (this.job.specialities && this.job.specialities.length)){
        this.form.get('specificInterpreterRequired').patchValue(true);
      }
    }
  }

  setDates(){
    if(this.job.ends_at){
      let endsAt = moment(this.job.ends_at);
      let startsAt = moment(this.job.starts_at);

      // Ends_at should be on same date or next as starts_at
      endsAt.set({
        date: startsAt.date(),
        month: startsAt.month(),
        year: startsAt.year()
      });

      // Next date if the hour is before starts_at time.
      if(endsAt.isBefore(startsAt)){
        endsAt.date(startsAt.date() + 1);
      }

      this.job.ends_at = endsAt.format();

      this.setIsTooShortJob();
    }


    this.setIsPastJob();
  }

  openPlacesSearchModal() {
    let modal = this.modalCtrl.create(PlacesSearchModal);
    modal.present();
  }

  openInterpreterSearchModal(){
    let modal = this.modalCtrl.create(InterpreterSearchModal);
    modal.present();
  }

  openColleagueSearchModal(){
    let modal = this.modalCtrl.create(ColleagueSearchModal);
    modal.present();
  }

  openParticipantsSearchModal(){
    let modal = this.modalCtrl.create(ColleagueSearchModal, {event: 'participant:selected'});
    modal.present();
  }

  openUndesirableInterpreterSearchModal(){
    let modal = this.modalCtrl.create(InterpreterSearchModal, {event: 'undesirable_interpreter:selected'});
    modal.present();
  }

  openSpecialitiesSelectModal(){
    let modal = this.modalCtrl.create(SpecialitiesSelectModal);
    modal.present();
  }

  openPreferredInterpreterSearchModal(){
    let modal = this.modalCtrl.create(InterpreterSearchModal, {event: 'preferred_interpreter:selected'});
    modal.present();
  }

  onFormSubmit(){
    this.submitted = true;
    if(!this.form.valid){
      return this.toast.show(this.translate.instant('global.form_invalid'));
    }
    this.job.editMode = false;
  }

  updateLanguage(val, inputNumber){
    this.job['language' + inputNumber + '_id'] = val ? val.id : null;
  }

  isEqual(model1, model2){
    return model1 && model2 ? model1.id === model2.id : model1 === model2;
  }

  onPreferredInterpreterSelected(interpreter: any, event?) {
    if(event){
      event.stopPropagation();
    }
    this.job.preferred_interpreter = interpreter;
    this.job.preferred_interpreter_id = interpreter? interpreter.id : null;
  }

  onUndesirableInterpreterSelected(interpreter: any) {
    // Don't add duplicates
    let filtered = this.job.undesirable_interpreters.filter(user => user.id === interpreter.id);
    if(filtered.length){
      return;
    }

    this.job.undesirable_interpreters.push(interpreter);
  }

  onSpecialitySelected(speciality: any) {
    // Don't add duplicates
    let filtered = this.job.specialities.filter(user => user.id === speciality.id);
    if(filtered.length){
      return;
    }

    this.job.specialities.push(speciality);
  }

  onInterpreterSelected(interpreter: User, event?) {
    if(event){
      event.stopPropagation();
    }

    if (!interpreter) {
      this.job.interpreter = null;
      this.job.interpreter_id = null;
      this.onInterpreterDeselected();
      return;
    }
    this.job.interpreter = interpreter;
    this.job.interpreter_id = interpreter.id;
    this.job.status = 'accepted';
    this.job.accepted_at = moment().toISOString();
  }

  onPublisherSelected(client: User, event?) {
    if(event){
      event.stopPropagation();
    }

    if (!client) {
      this.job.publisher = null;
      this.job.client_user_id = null;
      return;
    }
    this.job.client_user_id = client.id;
    this.job.publisher = client;

    if(this.job.participants.filter(user => user.id === client.id).length === 0){
      this.job.participants.push(client);
    }
  }

  onParticipantSelected(client){
    // Don't add duplicates
    let filtered = this.job.participants.filter(user => user.id === client.id);
    if(filtered.length){
      return;
    }

    this.job.participants.push(client);
  }

  removeUndesirableInterpreter(index){
    this.job.undesirable_interpreters.splice(index, 1);
  }

  removeSpeciality(index){
    this.job.specialities.splice(index, 1);
  }

  removeParticipant(index){
    this.job.participants.splice(index, 1);
  }

  private getJobTypes(){
    this.jobTypeService.getJobTypes()
      .subscribe(types => {
        this.jobTypes = {};
        types.forEach(type => {
          this.jobTypes[type.code] = type;
        });
        this.jobTypeKeys = Object.keys(this.jobTypes);
      });
  }

  private setIsPastJob(): void {
    this.jobIsInThePast = moment(this.job.starts_at).isBefore(moment());

    this.jobIsInThePastAlertVisible = this.jobIsInThePast;

    this.setValidators('interpreter', this.jobIsInThePast);
    if(this.jobIsInThePast){
      this.form.get('specificInterpreterRequired').setValue(false);
    }else{
      this.onInterpreterDeselected();
    }
  }

  private setIsTooShortJob() {
    if(typeof this.jobTypes[this.job.type] === 'undefined' || !this.job.ends_at){
      return;
    }
    let minDuration = this.jobTypes[this.job.type].min_hours;
    let duration = moment(this.job.ends_at).diff(moment(this.job.starts_at), 'hours', true);
    this.jobIsTooShortAlertVisible = duration < minDuration;
  }

  private onTypeValueChanges(value) {
    this.setValidators('ends_at', this.job.typeHasEndTime());
    this.setValidators('address', this.job.typeHasLocation());
    this.setValidators('remote_contact_info', this.job.typeHasRemoteContactInfo());

    if (!this.job.typeHasLocation()) {
      this.job.address = null;
      this.job.latitude = null;
      this.job.longitude = null;
    }

    if (!this.job.typeHasEndTime()) {
      this.job.ends_at = null;
    }

    if (!this.job.typeHasRemoteContactInfo()) {
      this.job.remote_contact_info = null;
    }

    this.setIsTooShortJob();

    return value;
  }

  private onSpecificInterpreterRequiredValueChanges(value: boolean) {
    if (value === false) {
      this.job.preferred_interpreter = null;
      this.job.preferred_interpreter_id = null;
      this.job.required_gender = null;
    }
  }

  private setValidators(controlName, ifCond) {
    let field = this.form.get(controlName);
    let validators = this.userControlsConfig[controlName][1];
    field.setValidators(ifCond ? validators : null);
    field.updateValueAndValidity();
  }

  private updateAddress(place) {
    if (place.hasOwnProperty('formatted_address')) {
      this.job.address = place.formatted_address;
      this.job.latitude = place.geometry.location.lat();
      this.job.longitude = place.geometry.location.lng();
    }
  }

  private onInterpreterDeselected(){
    if(!this.job.id){
      this.job.interpreter = null;
      this.job.interpreter_id = null;
      this.job.status = null;
      this.job.accepted_at = null;
    }
  }

  private prefillProfile() {
    // Prefill contact fields from profile
    this.profileService.getProfile()
      .subscribe(profile => {

        // Prefill contact person/owner
        this.job.publisher = profile;
        this.job.client_user_id = profile.id;
        this.form.get('publisher').patchValue(profile);

        // Prefill participants
        if(!this.job.participants.length){
          this.job.participants.push(profile);
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/job/job-edit-form/job-edit-form.component.ts